import Vue from "vue";
import iView from "view-design";
import "../../iview-theme/index.less";
// import "iview/dist/styles/iview.css";

Vue.use(iView);
